import Small from './Small';
import UserAvatar from './UserAvatar';

export default Object.assign(UserAvatar, { Small });
